import { Component, ElementRef, Input, OnInit } from '@angular/core'
import { removeNgTag } from '../../shared/utils/host'

@Component({
  selector: 'icos-main',
  template: `
    <main [class]="'icos-main ' + class">
      <ng-content></ng-content>
    </main>
  `,
})
export class IcosMain implements OnInit {

  @Input() class: string

  constructor(
    private el: ElementRef,
  ) {}

  ngOnInit(): void {
    console.log('icos Angular: Container Component is discarded, use [Container directive] replace it.')
    removeNgTag(this.el.nativeElement)
  }
}
